import { createGlobalStyle } from 'styled-components';
import Theme from '../Theme/Theme';


export const GlobalStyle = createGlobalStyle`
body, html, #root {
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: ${Theme.typography.fontFamily};

  //---Scroll---
  ::-webkit-scrollbar {
    width: 12px;               /* width of the entire scrollbar */
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;        /* color of the tracking area */
  }

  ::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;    /* color of the scroll thumb */
    border-radius: 20px;       /* roundness of the scroll thumb */
    border: 3px solid #f1f1f1;  /* creates padding around scroll thumb */
  }
  //------
}

.full-h {
  height: 100%!important;
}

.full-width{
  width: 100%;
}

.cursor-pointer{
  cursor: pointer;
}

.hidden{
  visibility: hidden;
  font-size: 0;
  height: 0;

  .widget-card{
    height: 0;
  }
}
.gm-style-cc { display:none; }

.background-color-gray{
  background-color: ${Theme.color['neutral-1']};
}

.ant-anchor-wrapper{
  font-family: ${Theme.typography.fontFamily};
  transition: all 0.3s ease;
  // overflow: hidden;

  .ant-anchor{
      background-color: ${Theme.color['neutral-1']};
      .ant-anchor-ink{
          display: none;
      }
      .ant-anchor-link{
        padding-inline: ${Theme.spacing['s08']} 0;
          .ant-anchor-link-title{
              font-size: ${Theme.typography.fontSize['text_sm_desktop']};
          }
      }
      .ant-anchor-link-active {
          .ant-anchor-link-title-active{
              font-weight: ${Theme.typography.weight['medium']};
              color: ${Theme.color['teal-6']};
          }
      }
      .ant-anchor-arrow{
        width: 30px;
        height: auto;
        background-color: red;
        /* Rotate div */
        -ms-transform: rotate(90deg);
        /* IE 9 */
        -webkit-transform: rotate(30deg);
        /* Chrome, Safari, Opera */
        transform: rotate(90deg);
        transform-origin: bottom left;
        position: relative;

        &::before,
        &::after {
          content: '';
          position: absolute;
          left: 0;
          border-style: solid;
          border-color: ${Theme.color['coolgray-4']} transparent;
        }

        &::before {
          bottom: 0;
          transform: translate(-40%, 50%);
          border-width: 20px 10px 0 10px;
        }

        &::after {
          top: 0;
          transform: translate(-40%, -50%);
          border-width: 0 10px 20px 10px;
        }
      }
  }

  &.ant-anchor-wrapper-horizontal::before{
      border-bottom: none;
  }

  .sticky {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 100;
  }
}

.ant-anchors-content{
  background-color: 'white';
  height: auto;
  
  .ant-anchors-content-item{
    width: auto;
    height: auto;
    padding-top: ${Theme.spacing.s08};
    &:first-child{
      padding-top : 0;
    }
    &:nth-child(odd){
      background-color: ${Theme.color['neutral-1']};
    }
  }
  .ant-anchors-content-item-white{
    width: auto;
    height: auto;
    &:first-child{
      padding-top : 0;
    }
    &:nth-child(odd){
      background-color: ${Theme.color['white']};
    }
  }
}

.recharts-legend-wrapper{
  .recharts-legend-item{
    display: flex;
    margin-bottom: ${Theme.spacing.s05};

    .recharts-legend-item-text{
      color: ${Theme.color['black-1']}!important;
      font-size: ${Theme.typography.fontSize.text_sm_desktop};
      margin-bottom: ${Theme.spacing.s05};
      margin-left: ${Theme.spacing.s04};
    }
  }
}

.donut-chart-Wrapper{
  height: 100%;
  margin-top: 48px;
  .simple-donout-chart-apex{
    svg{ 
      overflow: visible;
      foreignObject{
        height: 100%;
      }
    }
  }
  .apexcharts-toolbar{
    top: -48px!important;
  }
}
.apexcharts-toolbar{
  z-index: 1!important;
}

.fixed-top{
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;
  z-index: 2;
}

.ant-switch.ant-switch-checked{
  background: ${Theme.color['blue-3']};

  &:hover:not(.ant-switch-disabled) {
    background: ${Theme.color['blue-3']};
  }
}

.ant-checkbox-wrapper{
  &:hover .ant-checkbox .ant-checkbox-inner{
    border-color:  ${Theme.color['blue-3']};
  }
  &:hover .ant-checkbox.ant-checkbox-checked .ant-checkbox-inner{
    background-color: ${Theme.color['blue-3']}!important;
  }
  .ant-checkbox.ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${Theme.color['blue-4']};
    border-color:  ${Theme.color['blue-4']};
  }
  .ant-checkbox.ant-checkbox-indeterminate .ant-checkbox-inner:after {
    background-color: ${Theme.color['blue-4']};
  }

  &.ant-checkbox-disabled .ant-checkbox-inner {
    border-color:  transparent;
  }
}
.ant-picker.full-width{ width: 100%;}
.ant-picker:hover{
  border-color: ${Theme.color['blue-3']};
}
.ant-picker-focused.ant-picker{
  border-color: ${Theme.color['blue-3']};
}
.ant-picker-range .ant-picker-active-bar{
  background: ${Theme.color['blue-3']};
}
.ant-picker-dropdown {
  .ant-picker-week-panel-row-range-end, 
  .ant-picker-week-panel-row-range-start {
    td.ant-picker-cell:before {
    background: ${Theme.color['blue-3']};
    } 
  }

  .ant-picker-cell-in-view{
    &.ant-picker-cell-selected, 
    &.ant-picker-cell-range-start,
    &.ant-picker-cell-range-end {
      .ant-picker-cell-inner {
        background: ${Theme.color['blue-3']};
      }
    }
   
  }
}

.antd-complex-table .ant-checkbox-disabled .ant-checkbox-inner {
  border-color:  transparent;
}

.menuListActive{
  color: #000000 !important;
  border-bottom: 2px solid #86BC25;
}

.compact-table{
  .ant-table-wrapper .ant-table .ant-table-cell{
    padding: ${Theme.spacing.s03};
  }
}
.tariff-simulation-table{
  .ant-table-thead{ 
    .ant-table-cell{
      font-size: ${Theme.typography.fontSize.text_md_desktop};
      background-color: ${Theme.color['white']};
      line-height: 200%;
    }
  }
  .ant-table-row{
    text-align: right;
  }
  .ant-table-row[data-row-key~="reactiveEnergy"],
  .ant-table-row[data-row-key~="activeEnergy"],
  .ant-table-row[data-row-key~="potency"]{
    background-color: ${Theme.color['neutral-3']};
    font-weight : ${Theme.typography.weight.bold};
    font-size: ${Theme.typography.fontSize.text_md_desktop};
    line-height: 200%;
  }
  .ant-table-row::hover{
    background-color: ${Theme.color['neutral-3']};
  }

}


.ant-table-wrapper{ 
   .ant-table {
    font-family: ${Theme.typography.fontFamily};
    font-size: ${Theme.typography.fontSize.text_sm_desktop};
    color: ${Theme.color['coolgray-12']};
    border-radius: 0;
    a{
      color: ${Theme.color['blue-4']};
    }
    .ant-table-cell{
      padding: ${Theme.spacing.s05};
      .ant-table-filter-column {
        .ant-table-filter-trigger{
          &.active{
            .anticon-search{
              color: ${Theme.color['blue-4']};
            }
          }
        }
      }
    }
  }
  .ant-pagination{

    .ant-pagination-item{
      font-family: ${Theme.typography.fontFamily};
      font-size: ${Theme.typography.fontSize.text_sm_desktop};
      color: ${Theme.color['coolgray-12']};

      &.ant-pagination-item-active{
        background: none;
        border: none;
        font-weight: ${Theme.typography.weight.medium};
        a{
          color: ${Theme.color['blue-4']};
        }
      }
    }

    .ant-pagination-options{
      .ant-select{
        min-height: auto;
        font-family: ${Theme.typography.fontFamily};
        font-size: ${Theme.typography.fontSize.text_sm_desktop};
        color: ${Theme.color['coolgray-12']};

        .ant-select-selector:hover, .ant-select-selector:focus, &.ant-select-focused .ant-select-selector {
          border-color: ${Theme.color['blue-4']};
        }
        .ant-select-dropdown .ant-select-item-option:hover{
          background-color: ${Theme.color['neutral-3']};

          .ant-select-item-option-content{
            color: ${Theme.color['coolgray-12']};
          }
        }
      }
    }

    .ant-pagination-prev, .ant-pagination-next{
      background-color: ${Theme.color['neutral-2']};

      svg{
        fill: ${Theme.color['blue-4']};
      }
       
      &.ant-pagination-disabled {
        background-color: transparent;
        border: 1px solid ${Theme.color['coolgray-2']};
      }
    }
  }
}

.ant-radio-wrapper{
  font-family: ${Theme.typography.fontFamily};
  font-size: ${Theme.typography.fontSize.text_md_desktop};
  color: ${Theme.color['coolgray-12']};

  .ant-radio{
    &.ant-radio-checked .ant-radio-inner{
      background-color: ${Theme.color['blue-4']};
      border-color: ${Theme.color['blue-4']};
    }
    &::after{
      border-color: ${Theme.color['blue-4']};
    }
  }

  &:hover{
    .ant-radio:not(.ant-radio-disabled){
     .ant-radio-inner{
        border-color: ${Theme.color['blue-4']};
      }
    }
  }
}

.ant-radio-button-wrapper:not(.ant-radio-button-wrapper-disabled){
  font-family: ${Theme.typography.fontFamily};
  font-size: ${Theme.typography.fontSize.text_md_desktop};
  color: ${Theme.color['coolgray-12']};

  &.ant-radio-button-wrapper-checked{
    background-color: ${Theme.color['blue-4']};
    border-color: ${Theme.color['blue-4']};

    .ant-radio-button {
      &.ant-radio-button-checked{
        background-color: ${Theme.color['blue-4']};
        border-color: ${Theme.color['blue-4']};
      }
    }

    &::before{
      background-color: ${Theme.color['blue-4']};
    }
  }

  &:hover{
    color: ${Theme.color['blue-4']};

    &.ant-radio-button-wrapper-checked{
      border-color: ${Theme.color['blue-4']};
    }
  }

}

.ant-popconfirm{
  .ant-popover-content{
    .ant-popconfirm-buttons{
      .ant-btn{
        border-radius: ${Theme.radius['xl']};
        padding: ${Theme.spacing.s03} ${Theme.spacing.s05};
        font-size: ${Theme.typography.fontSize.ui_xs};

        &.ant-btn-primary{
          background-color:  ${Theme.color['blue-4']};
        }
      }
    }
  }
}

.d-flex {
  display: flex;
}


.ant-input{
  &:hover{
    border-color: ${Theme.color['blue-4']};
  }
  &:focus{
    border-color: ${Theme.color['blue-4']};
  }
 }
  

#header-dropdown .ant-dropdown-menu {
  z-index: 2000;
}

.synegry-anchors{
  a {
    color: ${Theme.color['coolgray-12']};
    &.active {
      color: ${Theme.color['blue-4']};
    }
  }
}

.ant-tooltip{
  .ant-tooltip-inner{
      color:${Theme.color['coolgray-12']} ;
  }

}
.solve-error{
  padding: 12px;
}
.solve-error-first{
  padding: 0px;
}
.solve-error-ciris{
  padding: 32px;
}
.solve-error-ciris-first{
  padding-top: 0px !important;
  background:${Theme.color['neutral-1']};
}
.noStyle{
 color: white;
}
.noStyle:hover{
  color: white;
}

.multiple-select-atomic{
  .ant-select-selector{
    .ant-select-selection-overflow{
      .ant-select-selection-overflow-item{
        align-self: flex-end;
      }
    }
  } 
}

.ant-select-dropdown .ant-select-item-option:not(.ant-select-group):hover{
  background-color: lightgray !important;
}

.ant-select-item-option-content{
  color: black !important;
}

.gm-style-iw-chr{
  height: 12px;
}

.gm-ui-hover-effect{
  visibility: hidden;
}

.ant-drawer-content-wrapper .my-drawer {
  width: 500px !important;
}

.ant-anchor-wrapper .ant-anchor .ant-anchor-link {
    padding-inline: 0;
    padding-left: 10px;
}
`;